/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GuaranteeReferentialDto
 */
export interface GuaranteeReferentialDto {
    /**
     * 
     * @type {string}
     * @memberof GuaranteeReferentialDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GuaranteeReferentialDto
     */
    deductible?: number;
    /**
     * 
     * @type {number}
     * @memberof GuaranteeReferentialDto
     */
    ceiling?: number;
}

/**
 * Check if a given object implements the GuaranteeReferentialDto interface.
 */
export function instanceOfGuaranteeReferentialDto(value: object): value is GuaranteeReferentialDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GuaranteeReferentialDtoFromJSON(json: any): GuaranteeReferentialDto {
    return GuaranteeReferentialDtoFromJSONTyped(json, false);
}

export function GuaranteeReferentialDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuaranteeReferentialDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'deductible': json['deductible'] == null ? undefined : json['deductible'],
        'ceiling': json['ceiling'] == null ? undefined : json['ceiling'],
    };
}

export function GuaranteeReferentialDtoToJSON(json: any): GuaranteeReferentialDto {
    return GuaranteeReferentialDtoToJSONTyped(json, false);
}

export function GuaranteeReferentialDtoToJSONTyped(value?: GuaranteeReferentialDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'deductible': value['deductible'],
        'ceiling': value['ceiling'],
    };
}

